import React, {ReactNode} from 'react';

import {TEntityValue} from 'modules/data';

import {
    SAVE_BUTTON_LABELS,
    EStepTitle,
    stepIndex,
} from './document-status-change-modal.constants';

export const getModalTitle = (
    selectedDocuments: Record<string, TEntityValue>[],
): ReactNode => {
    if (selectedDocuments.length > 1) {
        return 'Изменение статуса документов';
    }
    const docName = selectedDocuments[0]?.docName || '';
    return (
        <span>
            Изменение статуса документа
            <br />
            {docName}
        </span>
    );
};

export const getSaveButtonLabel = (currentStep: number): string => {
    switch (currentStep) {
    case stepIndex[EStepTitle.COMMENTS]:
        return SAVE_BUTTON_LABELS[EStepTitle.COMMENTS];
    case stepIndex[EStepTitle.PUBLISH]:
        return SAVE_BUTTON_LABELS[EStepTitle.PUBLISH];
    default:
        return '';
    }
};

export const sanitizeCommentValue = (commentValue: string | null): string | null => {
    if (!commentValue) {
        return commentValue;
    }

    return commentValue?.trim()?.replace('<p><br></p>', '');
};

export const getDocumentComment = (
    uniqueComment: string | null,
    sharedComment: string | null,
    isMultipleDocuments: boolean,
    hasAnyUniqueComment: boolean,
): string => {
    if (isMultipleDocuments) {
        if (uniqueComment) {
            return uniqueComment;
        }

        if (sharedComment) {
            return sharedComment;
        }

        if (hasAnyUniqueComment) {
            return 'Отсутствует';
        }

        return '';
    }

    return sharedComment || '';
};
